import './pendingCertification.less';
import * as _ from 'lodash';

/**
 * @typedef { import('../objects/PendingCertification').PendingCertification } PendingCertification
 */

angular.module("tromanWeb").controller('PendingCertificationController', ['$q', 'tromanServer', 'dialogService', 'stateService', function ($q, tromanServer, dialogService, stateService) {

    this._table = null;
    this.items = null;

    this.$onInit = function () {
        const params = stateService.getParams();

        this.filter = params.filter;
        this.filterPending = _.isUndefined(params.filterPending) || (!!params.filterPending);

        $q.all({
            pending: tromanServer.Payroll.getPendingCertification(),
        }).then(data => {
            /** @type {PendingCertification[]} */
            this.items = data.pending;
            this.items = _.orderBy(this.items, x => x.Organization.Name);
            _.forEach(this.items, x => {
                let criteria = { OrganizationIds: [ x.OrganizationId ] };
                if (x.CertifierId != null) {
                    criteria.CertifierIds = [ x.CertifierId ];
                } else {
                    criteria.IsAbandoned = true;
                }
                x.$criteria = criteria;
            });
        }).catch(err => {
            this.error = err;
        });
    };

    // We need to apply filter when table is available (it is not in $onInit).
    // This little hack does that
    // I have not found a clean solution yet ($postLink does not seem to be called)
    Object.defineProperty(this, 'table', {
        get: function() { return this._table; },
        set: function(val) {
            this._table = val;
            if (val) {
                val.search(this.filterPending, '$hasPending', true);
            }
        }
    });

    this.uiOnParamsChanged = function (changed) {
        if (_.has(changed, 'filter')) {
            this.filter = changed.filter;
        }
        if (_.has(changed, 'filterPending')) {
            this.filterPending = changed.filterPending;
            this.table?.search(this.filterPending, '$hasPending', true);
        }
    };

    this.filterChanged = function filterChanged() {
        stateService.replaceParams({ filter: this.filter });
    };

    this.filterPendingChanged = function filterChanged() {
        stateService.replaceParams({ filterPending: this.filterPending });
    };

    this.emailList = function emailList() {
        if (this.table == null) return;

        var list = _.chain(this.table.selectedItems())
            .map(x => x.Certifier)
            .reject(_.isNil)
            .uniqBy(x => x.Id)
            .value();

        dialogService.createEmailList(list);
    };
}]);
